import { SITE_URL } from '../../constants'
import { buildCaseStudySchema } from '../../builders/caseStudy'
import { PageMeta } from '../../types'

const description = "新たな事業アイデアを創出するワークショップを実施しました。このワークショップは中期経営方針を実現するために、全体最適実現のためのアイデアを網羅的に創出しました。イノベーション理論を用いたワークを行い、30個以上のアイデアを出しデジタルプロジェクト進行の支援まで実施しました。"

const ogpImg = "https://aitria.co.jp/images/img/cases/kayaba/ogp_kayaba.png"

export const kayabaPageMeta: PageMeta = {
  title: "イノベーション ワークショップ | 事例 | Aitria（アイトリア）",
  description,
  keyword: "DX戦略 組織開発 人材育成 生成AI デジタルトランスフォーメーション",
  image: ogpImg,
  url: `${SITE_URL}/cases/kayaba/`,
}

export const kayabaSchema = buildCaseStudySchema({
  slug: "kayaba",
  pageTitle: kayabaPageMeta.title,
  description: kayabaPageMeta.description,
  headline: "イノベーション ワークショップ",
  alternativeHeadline: "カヤバ株式会社",
  primaryImage: ogpImg,
  images: [ogpImg,"https://aitria.co.jp/images/img/cases/caseStudyTop/kayaba.webp"],
  clientName: "カヤバ株式会社",
  breadcrumbLabel: "イノベーション ワークショップ",
})
